import _slicedToArray from "@babel/runtime-corejs3/helpers/slicedToArray";
import * as React from 'react';
export default function useTextValueMapping(_ref) {
  var valueText = _ref.valueText,
      onTextChange = _ref.onTextChange;

  var _React$useState = React.useState(''),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      text = _React$useState2[0],
      setInnerText = _React$useState2[1];

  var valueTextRef = React.useRef('');
  valueTextRef.current = valueText;

  function triggerTextChange(value) {
    setInnerText(value);
    onTextChange(value);
  }

  function resetText() {
    setInnerText(valueTextRef.current);
  }

  React.useEffect(function () {
    if (valueText !== text) {
      resetText();
    } // eslint-disable-next-line react-hooks/exhaustive-deps

  }, [valueText]);
  return [text, triggerTextChange, resetText];
}